export const generateArray = ({
  length,
  start = 1,
  step = 1,
}: {
  length: number;
  start?: number;
  step?: number;
}): number[] => {
  return Array.from({ length }, (_, i) => i * step + start);
};
